import type { LanguagePack } from './types'

export const mr: LanguagePack = {
  navSaved: 'सेव्ह केलेले',
  navInfo: 'माहिती',
  homeTitle: 'तुमच्या कागदाचा फोटो काढा',
  homeHint: 'समझो सांगेल की कागदात काय लिहिलं आहे आणि तुम्हाला पुढे काय करायचं आहे.',
  takePhoto: 'फोटो काढा',
  uploadFile: 'फोटो किंवा PDF टाका',
  supportedFiles: 'फोटो (JPG, PNG, WEBP) किंवा PDF · 10 MB पर्यंत',
  chooseLanguage: 'कोणत्या भाषेत समजून घ्यायचं',
  privacyLine: 'तुमचा कागद याच फोनवर वाचला जातो. तुम्ही "सेव्ह करा" दाबल्याशिवाय काहीही सेव्ह होत नाही.',

  previewTitle: 'फोटो ठीक आहे का?',
  rotate: 'फिरवा',
  crop: 'कापा',
  cropDone: 'झालं',
  retake: 'पुन्हा काढा',
  readNow: 'वाचा',
  docLanguageLabel: 'कागद कोणत्या भाषेत लिहिला आहे?',
  docLanguageHint: 'इंग्रजी नेहमी सोबत वाचली जाते.',

  stepCheck: 'फोटो तपासला जात आहे…',
  stepRead: 'कागद वाचला जात आहे…',
  stepExtract: 'महत्त्वाची माहिती शोधली जात आहे…',
  stepExplain: 'मराठीत समजावून सांगत आहोत…',
  firstTimeNote: 'पहिल्यांदा थोडा जास्त वेळ लागेल, कारण वाचण्याचं टूल डाउनलोड होत आहे.',
  cancel: 'थांबवा',

  errBadImage: 'फोटो थोडा अस्पष्ट आहे. कृपया अजून एक स्पष्ट फोटो काढा.',
  errNoText: 'समझोला या कागदावर काहीही लिहिलेलं सापडलं नाही.',
  errUnclearPart: 'हा भाग समझोला नीट वाचता आला नाही.',
  errUnsupportedLanguage: 'या भाषेची सोय अजून नाही.',
  errLongDocument: 'हा कागद बराच मोठा आहे. आधी महत्त्वाची पानं निवडा.',
  errFileType: 'कृपया फोटो (JPG, PNG, WEBP) किंवा PDF निवडा.',
  errFileSize: 'ही फाईल 10 MB पेक्षा मोठी आहे. कृपया लहान फाईल निवडा.',
  errGeneric: 'काहीतरी चुकलं. कृपया पुन्हा प्रयत्न करा.',
  errOcrDownload: 'वाचण्याचं टूल डाउनलोड झालं नाही. एकदा इंटरनेट चालू करून पुन्हा प्रयत्न करा.',
  warnDark: 'फोटोत अंधार आहे. चांगल्या उजेडात काढलेला फोटो नीट वाचला जातो.',
  warnBlurry: 'फोटो धूसर दिसतोय. फोन स्थिर धरून पुन्हा काढा.',
  warnSmall: 'फोटो खूप लहान आहे. कागदाच्या जवळून फोटो काढा.',
  tryAgain: 'पुन्हा प्रयत्न करा',

  pickPagesHint: (max) => `जास्तीत जास्त ${max} पानं निवडा.`,
  pageLabel: (n) => `पान ${n}`,
  readSelectedPages: (n) => `${n} ${n === 1 ? 'पान' : 'पानं'} वाचा`,

  typeSure: (name) => `हे ${name} आहे असं दिसतंय.`,
  typeMaybe: (name) => `हे कदाचित ${name} असेल, पण समझोला पूर्ण खात्री नाही.`,
  typeUnknown: 'हा कागद कोणत्या प्रकारचा आहे, याची समझोला पूर्ण खात्री नाही.',
  docTypes: {
    income_certificate: { name: 'उत्पन्नाचा दाखला (इन्कम सर्टिफिकेट)', about: 'यात सरकारी नोंदीनुसार एखाद्या व्यक्तीचं किंवा कुटुंबाचं उत्पन्न लिहिलेलं असतं.' },
    caste_certificate: { name: 'जातीचा दाखला', about: 'यात व्यक्ती कोणत्या जातीची किंवा प्रवर्गाची आहे, हे लिहिलेलं असतं.' },
    domicile_certificate: { name: 'रहिवासी दाखला (डोमिसाईल)', about: 'यात व्यक्ती कायमची कुठे राहते, हे लिहिलेलं असतं.' },
    birth_certificate: { name: 'जन्माचा दाखला', about: 'ही जन्माची सरकारी नोंद आहे.' },
    death_certificate: { name: 'मृत्यूचा दाखला', about: 'ही मृत्यूची सरकारी नोंद आहे.' },
    electricity_bill: { name: 'वीज बिल', about: 'यात वापरलेली वीज आणि भरायचे पैसे लिहिलेले असतात.' },
    water_bill: { name: 'पाणी बिल', about: 'यात पाण्याचे भरायचे पैसे लिहिलेले असतात.' },
    ration_card: { name: 'रेशन कार्ड किंवा रेशनची सूचना', about: 'हे सरकारी दुकानातून रेशन मिळण्याबद्दल आहे.' },
    aadhaar: { name: 'आधारशी संबंधित कागद', about: 'हे आधार नंबर किंवा आधारच्या माहितीबद्दल आहे.' },
    pan_card: { name: 'पॅनशी संबंधित कागद', about: 'हे पॅन (टॅक्स ओळख) नंबरबद्दल आहे.' },
    bank_notice: { name: 'बँकेचं पत्र', about: 'हे बँकेकडून आलेलं पत्र किंवा सूचना आहे.' },
    loan_notice: { name: 'कर्जाची (लोन) सूचना', about: 'हे एखाद्या कर्जाबद्दल किंवा बाकी असलेल्या पैशांबद्दल आहे.' },
    income_tax_notice: { name: 'आयकराची (इन्कम टॅक्स) सूचना', about: 'हे आयकर विभागाकडून आलं आहे.' },
    pension: { name: 'पेन्शनबद्दलचं पत्र', about: 'हे पेन्शनबद्दल आहे.' },
    court_notice: { name: 'कोर्टाची किंवा कायदेशीर नोटीस', about: 'हे कोर्टाकडून आलं आहे किंवा एखाद्या कायदेशीर प्रकरणाबद्दल आहे. हे गांभीर्याने घ्या.' },
    land_record: { name: 'जमिनीची नोंद', about: 'हे जमिनीच्या मालकीबद्दल किंवा जमिनीच्या माहितीबद्दल आहे.' },
    property_tax: { name: 'घरपट्टीचं (प्रॉपर्टी टॅक्स) बिल', about: 'हे घर किंवा मालमत्तेच्या टॅक्सबद्दल आहे.' },
    scholarship: { name: 'शिष्यवृत्तीचं (स्कॉलरशिप) पत्र', about: 'हे शिक्षणासाठी मिळणाऱ्या शिष्यवृत्तीबद्दल आहे.' },
    farmer_scheme: { name: 'शेतकरी योजनेचं पत्र', about: 'हे शेतकऱ्यांसाठीच्या एखाद्या योजनेबद्दल किंवा मदतीबद्दल आहे.' },
    school_letter: { name: 'शाळेचं पत्र', about: 'हे शाळेकडून आलं आहे किंवा शिक्षणाबद्दल आहे.' },
    marksheet: { name: 'गुणपत्रक (मार्कशीट) किंवा निकाल', about: 'यात परीक्षेचे मार्क किंवा निकाल लिहिलेला आहे.' },
    insurance: { name: 'विम्याचा कागद', about: 'हे एखाद्या विमा पॉलिसीबद्दल आहे.' },
    traffic_challan: { name: 'ट्रॅफिक चलन', about: 'हा ट्रॅफिक किंवा गाडीचा नियम मोडल्याबद्दलचा दंड आहे.' },
    job_notice: { name: 'नोकरी किंवा परीक्षेची सूचना', about: 'हे सरकारी नोकरी, भरती किंवा तिच्या परीक्षेबद्दल आहे.' },
    application_receipt: { name: 'अर्जाची पावती', about: 'यावरून कळतं की अर्ज जमा झाला आहे.' },
    application_decision: { name: 'अर्जाबद्दलचं पत्र', about: 'यात एखाद्या अर्जाचा निर्णय किंवा माहिती दिली आहे.' },
    government_notice: { name: 'सरकारी सूचना', about: 'ही एखाद्या सरकारी कार्यालयाची सूचना किंवा आदेश आहे.' },
    lab_report: { name: 'वैद्यकीय तपासणी अहवाल', about: 'यात रक्त किंवा इतर वैद्यकीय तपासण्यांचे निकाल आहेत.' },
    rental_agreement: { name: 'भाडे करार', about: 'हा घरमालक आणि भाडेकरू यांच्यातील करार आहे.' },
    loan_agreement: { name: 'कर्ज करार', about: 'यात कर्जाच्या अटी आहेत: व्याज, EMI आणि शुल्क.' },
    contract: { name: 'एक करार', about: 'हा एक करार आहे, ज्याच्या अटी दोन्ही बाजूंनी पाळायच्या असतात.' },
    unknown: { name: 'कागद', about: '' }
  },

  seedhiBaat: 'सोप्या शब्दांत',
  docSays: 'कागदात लिहिलं आहे',
  samjhoSays: 'समझो सांगतो',
  unclearText: 'हा भाग नीट वाचता आला नाही — कृपया मूळ कागद बघा.',

  aboutPerson: (name) => `हा कागद ${name} यांच्याबद्दल आहे.`,
  issuedBy: (authority) => `हा कागद इथून आला आहे: ${authority}.`,
  status: {
    approved: 'अर्ज मंजूर झाला आहे.',
    rejected: 'अर्ज नामंजूर (रिजेक्ट) झाला आहे.',
    pending: 'अर्जावर अजून काम चालू आहे. अजून निर्णय झालेला नाही.',
    cancelled: 'हे रद्द केलं आहे.'
  },
  dateSentence: {
    deadline: (d) => `शेवटची तारीख: ${d}.`,
    due: (d) => `पैसे भरण्याची शेवटची तारीख: ${d}.`,
    hearing: (d) => `कागदात हजर राहण्यासाठी ही तारीख दिली आहे: ${d}.`,
    issue: (d) => `हा कागद ${d} रोजी दिला आहे.`,
    validity: (d) => `हा कागद ${d} पर्यंत वैध आहे.`,
    birth: (d) => `जन्मतारीख लिहिली आहे: ${d}.`,
    other: (d) => `एक तारीख लिहिली आहे: ${d}.`
  },
  daysLeft: (days) => (days === 1 ? '1 दिवस बाकी आहे.' : `${days} दिवस बाकी आहेत.`),
  dueToday: 'ही तारीख आजच आहे.',
  datePassed: 'लक्षात घ्या: ही तारीख निघून गेली आहे.',
  amountSentence: {
    payable: (a) => `भरायची रक्कम: ${a}.`,
    income: (a) => `लिहिलेलं उत्पन्न: ${a}.`,
    fine: (a) => `दंड किंवा उशिराचं शुल्क लिहिलं आहे: ${a}.`,
    fee: (a) => `फी लिहिली आहे: ${a}.`,
    sanctioned: (a) => `मंजूर झालेली किंवा पाठवलेली रक्कम: ${a}.`,
    other: (a) => `एक रक्कम लिहिली आहे: ${a}.`
  },
  actionsPointer: 'कागदात तुम्हाला काहीतरी करायला सांगितलं आहे. खाली "तुम्हाला काय करायचं आहे" बघा.',
  noActionFound: 'कागदात तुम्हाला काही करायला सांगितलं आहे, असं स्पष्ट लिहिलेलं नाही.',
  keepSafe: 'हा कागद जपून ठेवा.',
  doBefore: (d) => `हे काम ${d} च्या आधी करा.`,
  bringDocs: (list) => `हे कागद तयार ठेवा: ${list}.`,
  contactFor: (c) => `काही प्रश्न असल्यास इथे संपर्क करा: ${c}.`,
  warningPointer: 'कागदात एक इशारा लिहिलेला आहे. तो नीट वाचा.',
  rejectedNext: 'ही चूक आहे असं वाटत असेल, तर ज्या कार्यालयाकडून हे पत्र आलं, तिथे विचारा.',
  lowQuality: 'फोटो फारसा स्पष्ट नव्हता, त्यामुळे काही गोष्टी चुकीच्या वाचल्या गेल्या असू शकतात. मूळ कागदाशी जुळवून बघा.',

  cardTodo: 'तुम्हाला काय करायचं आहे',
  cardDates: 'महत्त्वाच्या तारखा',
  cardAmount: 'रक्कम',
  cardWhere: 'कुठे जायचं',
  cardWarnings: 'लक्ष द्या',
  cardDocs: 'कोणते कागद लागतील',
  cardPerson: 'कोणाबद्दल',
  cardFrom: 'कोणी पाठवलं',
  cardNumbers: 'महत्त्वाचे नंबर',
  cardContact: 'संपर्क',
  refKinds: {
    application: 'अर्ज नंबर',
    certificate: 'दाखला नंबर',
    consumer: 'ग्राहक नंबर',
    account: 'खाते नंबर',
    case: 'केस नंबर',
    reference: 'पत्र नंबर',
    registration: 'नोंदणी नंबर',
    receipt: 'पावती नंबर',
    other: 'नंबर'
  },
  requiredDocNames: {
    aadhaar: 'आधार कार्ड',
    pan: 'पॅन कार्ड',
    ration_card: 'रेशन कार्ड',
    voter_id: 'मतदार ओळखपत्र (वोटर आयडी)',
    passbook: 'बँक पासबुक',
    photo: 'फोटो',
    income_certificate: 'उत्पन्नाचा दाखला',
    caste_certificate: 'जातीचा दाखला',
    domicile_certificate: 'रहिवासी दाखला',
    birth_certificate: 'जन्माचा दाखला',
    land_record: 'जमिनीची नोंद',
    electricity_bill: 'वीज बिल',
    address_proof: 'पत्त्याचा पुरावा',
    id_proof: 'ओळखपत्र',
    affidavit: 'प्रतिज्ञापत्र (ॲफिडेव्हिट)',
    application_form: 'अर्जाचा फॉर्म'
  },

  voiceDownloadNote: 'पहिल्यांदा आवाज डाउनलोड होत आहे (सुमारे 58 MB). त्यानंतर इंटरनेटशिवायही चालेल.',

  listen: 'ऐकवा',
  pause: 'थांबा',
  resume: 'पुढे ऐकवा',
  stop: 'बंद करा',
  noVoice: 'या फोनमध्ये मराठी आवाज नाही.',
  noVoiceHint: 'फोनच्या सेटिंगमध्ये (Text-to-speech) आवाज जोडता येईल, किंवा दुसऱ्या भाषेत ऐका.',
  listenInHindi: 'हिंदीत ऐकवा',
  listenInEnglish: 'इंग्रजीत ऐकवा',
  noSpeechSupport: 'हा ब्राउझर मोठ्याने वाचून दाखवू शकत नाही.',

  disclaimer: 'समझो तुमचा कागद सोपा करून सांगतो. महत्त्वाच्या गोष्टी नेहमी मूळ कागदाशी किंवा तो देणाऱ्या कार्यालयाशी जुळवून बघा. समझो ही सरकारी सेवा नाही आणि हा कायदेशीर सल्ला नाही.',
  fullText: 'समझोने काय वाचलं',
  fullTextHint: 'रंगवलेल्या ओळी नीट वाचता आल्या नाहीत.',
  newDocument: 'नवा कागद',
  save: 'या फोनवर सेव्ह करा',
  saved: 'या फोनवर सेव्ह झालं',
  share: 'शेअर करा',
  copied: 'कॉपी झालं',
  translateLines: 'कागदातल्या इंग्रजी ओळी मराठीत बघा',
  helperMode: 'हेल्पर मोड',
  helperModeHint: 'इतरांचे कागद वाचून देणाऱ्यांसाठी (CSC, NGO, स्वयंसेवक). यात सेव्ह बंद असते, आणि "पुढची व्यक्ती" दाबल्यावर सर्व पुसले जाते.',
  nextPerson: 'पुढची व्यक्ती',
  listenMode: 'ऐकण्याचा मोड',
  listenModeHint: 'स्पष्टीकरण तयार होताच समझो ते आपोआप वाचून दाखवते.',
  settingsTitle: 'सेटिंग्ज',
  shareVoiceNote: 'व्हॉइस नोट पाठवा',
  makingVoiceNote: 'व्हॉइस नोट तयार होत आहे…',
  voiceNoteFailed: 'या फोनवर व्हॉइस नोट तयार होऊ शकली नाही.',
  translateOtherLines: 'कागदातल्या इतर भाषेतील ओळी मराठीत बघा',
  translateAiNote: 'ज्या ओळी इंग्रजीत नाहीत, त्यांचे भाषांतर एक AI सेवा (Groq) करते.',
  translateConsent: 'भाषांतरासाठी या ओळी इंटरनेटवरून समझोच्या सर्व्हरवर पाठवल्या जातील. तिथे त्या सेव्ह होत नाहीत. आधार आणि फोनसारखे नंबर आधीच काढून टाकले जातात.',
  translateConfirm: 'हो, भाषांतर करा',
  translating: 'भाषांतर होत आहे…',
  translateNote: 'मशीनने केलेलं भाषांतर — चुका असू शकतात.',
  translateFailed: 'आत्ता भाषांतर होऊ शकलं नाही.',
  retryRotated: 'फोटो फिरवून पुन्हा वाचा',

  addToCalendar: 'कॅलेंडरमध्ये आठवण जोडा',
  askTitle: 'या कागदाबद्दल विचारा',
  askHint: 'आपल्या शब्दांत विचारा. समझो तुमच्या कागदावरून उत्तर देईल — आणि तिथे नसेल, तर फक्त सरकारी वेबसाइटवरून.',
  askPlaceholder: 'तुमचा प्रश्न लिहा किंवा बोला…',
  askSend: 'विचारा',
  askMic: 'बोलून विचारा',
  askListening: 'ऐकत आहे… आता बोला',
  askWebToggle: 'गरज असल्यास सरकारी वेबसाइटही पाहा',
  askConsent: 'उत्तर देण्यासाठी या कागदातील मजकूर आणि तुमचा प्रश्न इंटरनेटवरून समझोच्या सर्व्हरवर आणि एका AI सेवेवर (Groq) पाठवला जाईल. आधार, पॅन, फोन नंबर आणि ईमेल आधीच काढून टाकले जातात. काहीही सेव्ह होत नाही.',
  askOfficialOnly: 'फक्त सरकारी वेबसाइट पाहिल्या जातात, जसे:',
  askConsentConfirm: 'ठीक आहे, विचारा',
  askThinkingDoc: 'तुमचा कागद वाचत आहे',
  askThinkingWeb: 'सरकारी वेबसाइट पाहत आहे',
  askFromDoc: 'तुमच्या कागदावरून',
  askFromWeb: 'सरकारी वेबसाइटवरून',
  askNotFound: 'समझोला हे तुमच्या कागदात किंवा सरकारी वेबसाइटवर सापडले नाही. ज्या कार्यालयाने हा कागद पाठवला, त्यांना विचारा.',
  askUnverified: 'समझो हे कागदातील नेमक्या ओळीशी जुळवू शकला नाही. कृपया कागद पाहून तपासा.',
  askSources: 'स्रोत',
  askOfficial: 'सरकारी',
  askFailed: 'आत्ता उत्तर मिळू शकले नाही. पुन्हा प्रयत्न करा.',
  askBusy: 'आत्ता खूप प्रश्न येत आहेत. एक मिनिट थांबून पुन्हा विचारा.',
  askAiNote: 'ही उत्तरे AI ने लिहिली आहेत, त्यात चूक असू शकते. महत्त्वाच्या गोष्टी कार्यालयाकडून खात्री करून घ्या.',
  askTryNext: 'तुम्ही हेही विचारू शकता:',
  askJump: 'प्रश्न विचारा',
  askSuggest: {
    fillForm: 'हा फॉर्म कसा भरायचा? प्रत्येक रकाना समजावून सांगा.',
    first: 'मी आधी काय करायला हवे?',
    deadline: 'शेवटची तारीख चुकली तर काय होईल?',
    pay: 'हे कसे आणि कुठे भरायचे?',
    papers: 'हे कागद कुठून मिळतील?',
    rejected: 'हे का नाकारले गेले, आणि आता मी काय करू शकतो?',
    meaning: 'हा कागद अगदी सोप्या शब्दांत समजावून सांगा.',
    contact: 'याबद्दल कोणाशी संपर्क करू?',
    schemes: 'या कागदानुसार मी कोणत्या सरकारी योजनांसाठी पात्र असू शकतो?'
  },

  helpTitle: 'मदत मिळवा',
  nearbyTitle: 'सर्वात जवळचे कार्यालय',
  nearbyNote: 'तुमच्या जवळचा नकाशा उघडेल. तुमचे लोकेशन फक्त नकाशाला जाते — समझो ते पाहत नाही आणि साठवत नाही.',
  locating: 'तुमचे लोकेशन शोधत आहे…',
  schemesTitle: 'सरकारी योजना',
  schemesText: 'या कागदानुसार कोणत्या योजना तुमच्या कामाच्या असू शकतात, हे समझो सरकारी योजनांच्या वेबसाइटवर पाहू शकतो.',
  schemesButton: 'माझ्यासाठी योजना शोधा',
  legalTitle: 'मोफत कायदेशीर मदत',
  legalText: 'विधी सेवा प्राधिकरणाकडून तुम्हाला मोफत वकील मिळू शकतो — उदा. महिला, मुले, SC/ST, कामगार, दिव्यांग आणि कमी उत्पन्न असलेले लोक.',
  legalCall: (n) => `${n} वर कॉल करा (मोफत)`,
  legalNearby: 'सर्वात जवळचे विधी सेवा प्राधिकरण',
  legalMore: 'अधिक कायदेशीर मदत',
  legalAskConsent: 'तुमचा प्रश्न इंटरनेटवरून समझोच्या सर्व्हरवर आणि एका AI सेवेवर (Groq) पाठवला जाईल, जे उत्तर फक्त सरकारी वेबसाइटवर शोधतात. आधार, पॅन, फोन नंबर आणि ईमेल आधीच काढून टाकले जातात. काहीही सेव्ह होत नाही.',
  navLegal: 'कायदेशीर मदत'
}
